<div class="fuse-vertical-navigation-wrapper">
    <!-- Header -->
    <div class="fuse-vertical-navigation-header">
        <ng-content select="[fuseVerticalNavigationHeader]" />
    </div>
    <!-- Content -->
    <div
        class="fuse-vertical-navigation-content"
        fuseScrollbar
        [fuseScrollbarOptions]="{ wheelPropagation: inner(), suppressScrollX: true }"
        #navigationContent
    >
        <!-- Content header -->
        <div class="fuse-vertical-navigation-content-header">
            <ng-content select="[fuseVerticalNavigationContentHeader]" />
        </div>
        <!-- Items -->
        @for (item of navigation(); track trackByFn($index, item)) {
            <!-- Skip the hidden items -->
            @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                <!-- Aside -->
                @if (item.type === 'aside') {
                    <fuse-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name()"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse()"
                        [skipChildren]="true"
                        (click)="toggleAside(item)"
                    />
                }
                <!-- Basic -->
                @if (item.type === 'basic') {
                    <fuse-vertical-navigation-basic-item [item]="item" [name]="name()" />
                }
                <!-- Collapsable -->
                @if (item.type === 'collapsable') {
                    <fuse-vertical-navigation-collapsable-item [item]="item" [name]="name()" [autoCollapse]="autoCollapse()" />
                }
                <!-- Divider -->
                @if (item.type === 'divider') {
                    <fuse-vertical-navigation-divider-item [item]="item" [name]="name()" />
                }
                <!-- Group -->
                @if (item.type === 'group') {
                    <fuse-vertical-navigation-group-item [item]="item" [name]="name()" [autoCollapse]="autoCollapse()" />
                }
                <!-- Spacer -->
                @if (item.type === 'spacer') {
                    <fuse-vertical-navigation-spacer-item [item]="item" [name]="name()" />
                }
            }
        }
        <!-- Content footer -->
        <div class="fuse-vertical-navigation-content-footer">
            <ng-content select="[fuseVerticalNavigationContentFooter]" />
        </div>
    </div>
    <!-- Footer -->
    <div class="fuse-vertical-navigation-footer">
        <ng-content select="[fuseVerticalNavigationFooter]" />
    </div>
</div>
<!-- Aside -->
@if (activeAsideItemId) {
    <div
        class="fuse-vertical-navigation-aside-wrapper"
        fuseScrollbar
        [fuseScrollbarOptions]="{ wheelPropagation: false, suppressScrollX: true }"
        [@fadeInLeft]="position() === 'left'"
        [@fadeInRight]="position() === 'right'"
        [@fadeOutLeft]="position() === 'left'"
        [@fadeOutRight]="position() === 'right'"
    >
        <!-- Items -->
        @for (item of navigation(); track trackByFn($index, item)) {
            <!-- Skip the hidden items -->
            @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                <!-- Aside -->
                @if (item.type === 'aside' && item.id === activeAsideItemId) {
                    <fuse-vertical-navigation-aside-item [item]="item" [name]="name()" [autoCollapse]="autoCollapse()" />
                }
            }
        }
    </div>
}
